import { makeStyles } from '@mui/styles';
import Typography from '@classify/react-core-components/Typography';
import { translate } from '@openclassrooms/translations';
import StartNowButton from './StartNowButton';
import ContinueCourseButton from './ContinueCourseButton';
import FollowCourseButton from './FollowCourseButton';
import useCourseStatus from '../hooks/useCourseStatus';

const useStyles = makeStyles(
  ({ breakpoints, spacing }) => ({
    actionWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      flexShrink: 0,
    },
    startNowButton: {
      marginTop: spacing(1),
      [breakpoints.up('sm')]: {
        marginTop: spacing(2),
      },
    },
  }),
  { classNamePrefix: 'FooterAction' }
);

function FooterAction() {
  const classes = useStyles();
  const { isFinished, hasAlreadyFollowed, notStarted, isFollowing } = useCourseStatus();

  if (isFinished) {
    return null;
  }

  if (hasAlreadyFollowed) {
    return (
      <div className={classes.actionWrapper} data-testid="course-footer">
        <FollowCourseButton>{translate('course.reenroll.button')}</FollowCourseButton>
      </div>
    );
  }

  if (notStarted) {
    return (
      <div className={classes.actionWrapper} data-testid="course-footer">
        <Typography variant="subheading" component="span" style={{ textAlign: 'center' }}>
          {translate('course.bottom_banner.incentive')}
        </Typography>

        <div className={classes.startNowButton}>
          <StartNowButton />
        </div>
      </div>
    );
  }

  if (isFollowing) {
    return (
      <div className={classes.actionWrapper} data-testid="course-footer">
        <ContinueCourseButton />
      </div>
    );
  }

  return null;
}

export default FooterAction;
